import styled from "styled-components";

export const PortfolioContainer = styled.div`
  align-items: center;
  justify-content: center;
  background-color: #010515;
  height: fit-content;
  padding: 48px;
  padding: 24px;
  padding: 24px;
  position: sticky;
  z-index: 1;
`;
